import { Component, Input, Output, OnChanges, EventEmitter } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { Question } from '../../../../../data/models'
import { LabelPrompt } from '../../../../../forms/models'
import { QuestionViewService, IQuestionAnswer } from '../../'

@Component({
  selector: 'mp-hide-show-choice-view',
  templateUrl: './hide-show-choice-view.html',
  styleUrls: ['./hide-show-question-view.scss']
})
export class HideShowChoiceViewComponent implements OnChanges {
  @Input() public answerChoicePrompt: LabelPrompt
  @Input() public formGroup: FormGroup

  public toggle: string = 'hidden'
  public toggleButtonText: string = 'Show Answer'

  public constructor(
    private _questionViewService: QuestionViewService
  ) {}

  public ngOnChanges() {
    this.toggle = 'visible'
    this.toggleAnswer()
  }

  public toggleAnswer() {
    this.toggle = this.is_answer_hidden() ? 'visible' : 'hidden'
    this.toggleButtonText = this.is_answer_hidden() ? 'Show Answer' : 'Hide Answer'
  }

  private is_answer_hidden(): boolean {
    return this.toggle === 'hidden'
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/choice-views/hide-show-choice-view/hide-show-choice-view.component.ts